<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Регистрация</h1>
      <p class="auth-note">Первый зарегистрированный пользователь становится администратором.</p>
      <p v-if="error" class="auth-error">{{ error }}</p>
      <q-input outlined v-model="name" label="Имя" autocomplete="name" />
      <q-input outlined v-model="email" type="email" label="Email" autocomplete="username" />
      <q-input outlined v-model="password" type="password" label="Пароль" autocomplete="new-password" @keyup.enter="submit" />
      <q-btn color="primary" label="Создать аккаунт" :loading="loading" @click="submit" />
      <div class="auth-links">
        <router-link to="/login">Уже есть аккаунт</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/auth";

export default {
  name: 'RegisterView',
  data() {
    return {
      name: '',
      email: '',
      password: '',
      error: '',
      loading: false,
      auth: new AuthService(),
    };
  },
  methods: {
    async submit() {
      this.error = '';
      this.loading = true;
      try {
        await this.auth.register(this.email, this.name, this.password);
        await this.$router.push('/');
      } catch (err) {
        this.error = err.message || 'Не удалось зарегистрироваться';
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
  padding: 24px;
}
.auth-card {
  width: min(420px, 100%);
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 28px;
  background: #fff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(20, 32, 51, 0.06);
  text-align: left;
  h1 {
    margin: 0;
    color: #202938;
  }
}
.auth-note, .auth-error {
  margin: 0;
}
.auth-note {
  color: #546179;
}
.auth-error {
  color: #c10015;
}
.auth-links a {
  color: #1976d2;
}
</style>
